import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class IReportService  {
    abstract getSandReport() : Observable<any>;
    abstract getPostAnalysisReport(jobs:string[]) : Observable<string>;
    abstract getCompanyUserReport() : Observable<string>;
}